/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListShiftTemplatesRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {ListShiftTemplatesResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const listShiftTemplates = (request: ListShiftTemplatesRequest, options?: CashRequestOptions) => post<ListShiftTemplatesRequest, ListShiftTemplatesResponse>("/2.0/cash/list-shift-templates", request, {...options, rejectOnError: true })